module.exports = __webpack_public_path__ + "img/ava-gardner-logo.4e381a1d.jpg";